import querystringify from "querystringify";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useActions } from "../../../hooks/useActions";
import useDatalayer from "../../../hooks/useDatalayer";
import { browser } from "../../../libs/helpers/browser";
import { setHistory, setQueryString } from "../../../redux/page/page.actions";
import { PageService } from "../../../redux/page/page.service";

const Page = ({ children }) => {
    const history = useHistory();
    const { search, pathname } = useLocation();
    const { partner, partnerType } = useSelector(state => ({
        ...state.HomeInsurance,
    }));
    const actions = useActions(
        {
            setHistory,
            setQueryString,
        },
        []
    );
    useEffect(() => {
        actions.setHistory(history);
    }, [actions, history]);
    useEffect(() => {
        const { webpSupported } = browser;
        document.body.className += `${webpSupported ? " webpSupported" : ""}`;
    }, []);
    useEffect(() => {
        const _parsedQuery = querystringify.parse(search);
        if (_parsedQuery.fijo === "1" && !PageService.isEnabledFullPlanPage(pathname)) {
            delete _parsedQuery.fijo;
            const _newSearch = querystringify.stringify(_parsedQuery);
            const _oldUrl = window.location.href;
            const _urlWithoutQuery = _oldUrl.substr(0, _oldUrl.indexOf("?"));
            const _newUrl = `${_urlWithoutQuery}${_newSearch ? `?${_newSearch}` : ""}`;
            window.location.href = _newUrl;
        } else {
            actions.setQueryString(search);
        }
    }, [actions, search, pathname]);
    useDatalayer({ partner, partnerType, history });
    return children;
};

export default Page;
